import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useExam } from '../context/ExamContext';
import { Candidate } from '../types/domain';
import { ExamState } from '../types/domain';

export function ProtectedRoute({ roles, children }: { roles: Candidate['role'][]; children: ReactNode }) {
  const { state } = useExam();
  const location = useLocation();
  if (!state.candidate) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!roles.includes(state.candidate.role)) return <Navigate to={state.candidate.role === 'candidate' ? '/instructions' : '/'} replace />;
  return <>{children}</>;
}

export function CandidateWorkflowRoute({ required, children }: { required?: keyof ExamState['workflow']; children: ReactNode }) {
  const { state } = useExam();
  const location = useLocation();
  if (!state.candidate) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (state.candidate.role !== 'candidate') return <Navigate to="/" replace />;
  const workflow = state.workflow;
  if (required === 'instructionsAcknowledged' && !workflow.instructionsAcknowledged) return <Navigate to="/instructions" replace />;
  if (required === 'permissionsCompleted' && !workflow.permissionsCompleted) return <Navigate to={workflow.instructionsAcknowledged ? '/permissions' : '/instructions'} replace />;
  if (required === 'cameraSetupCompleted' && (!workflow.cameraSetupCompleted || state.calibration?.readiness !== 'ready')) return <Navigate to={workflow.permissionsCompleted ? '/camera-setup' : workflow.instructionsAcknowledged ? '/permissions' : '/instructions'} replace />;
  return <>{children}</>;
}

export function CompletedCandidateRoute({ children }: { children: ReactNode }) {
  const { state } = useExam();
  const location = useLocation();
  if (!state.candidate) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (state.candidate.role !== 'candidate') return <Navigate to="/" replace />;
  if (!state.finishedAt || state.reportSessionId !== state.candidate.sessionId) {
    return <Navigate to="/instructions" replace />;
  }
  return <>{children}</>;
}
